import React from "react";
import 'react-toastify/dist/ReactToastify.css';
import WeatherWrapper from "../components/4Templates/WeatherWrapper";
import Layout from "../components/layout";
import "../styles/main.scss";

const IndexPage = () => {
return <Layout>
          <WeatherWrapper />
       </Layout>
}

export default IndexPage;